import React from "react";

interface Props {}

const ContentsGR: React.FC<Props> = (props) => {
  return (
    <div className="Contents container padding100" id="contents">
      <h6>AL-MARE</h6>
      <h1>Περιεχόμενα</h1>
      <div className="row">
        <div className=" col-12 col-lg-4  pb-3 pb-lg-0">
          <img src="content1.jpg" alt="" className="w-100" />
        </div>
        <div className="col-12 col-lg-8">
          <p>
            H κομψή πισίνα μας και με το μεσογειακό κήπο μας είναι οι κύριες
            ανέσεις για να απολαύσετε . Δίπλα γεύματα και δείπνα δίπλα στην
            πισίνα, και τα σνακ στο "Αλ Μάρε", a-la-carte εστιατόριο δίπλα στην
            πισίνα φτιάχνει ομορφιά για τα μάτια σας και ουρανό για την ψυχή
            σας.
            <br />
            <br />
            Το εστιατόριο "Αλ Μάρε" προσφέρει παραδοσιακό ελληνικό μενού , αλλά
            επίσης και το ευρωπαϊκό μενού, οι οποίοι θα ανταποκρίνονται στις
            προτιμήσεις του κάθε επισκέπτη . Οι πελάτες μας μπορούν να
            απολαύσουν τον πρωινό καφέ τους δίπλα στη θάλασσα , ή να δοκιμάσουν
            μερικά από τα καταπληκτικά ποτά μας, απολαμβάνοντας τον ήλιο δίπλα
            στην πισίνα γεμάτη με γλυκό νερό , στο "Al Mare beach bar".
            <br />
            <br />Η ρεσεψιόν δουλεύει από τις 7:00 έως τις 22:00 καθημερινά ,
            προσφέροντας οργάνωση ημερήσιων εκδρομών και υπηρεσίες, μεταφορές
            από και προς το αεροδρόμιο της Θεσσαλονίκης , κλπ.
          </p>
        </div>
      </div>
        <div className="row py-4">
          <div className=" col-12 col-lg-4 pb-3 pb-lg-0">
            <img src="content3.jpg" alt="" className="w-100" />
          </div>
          <div className="col-12 col-lg-8">
            <img src="content2.jpg" alt="" className="w-100" />
          </div>
        </div>
    </div>
  );
};

export default ContentsGR;
